import { defineComponent as _defineComponent } from 'vue'
import { nextTick, computed, ref } from 'vue'
import {
  useGetQuestionnairesForVenturesAndLabelQuery,
  type AccountType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEsgReferencePeriods',
  props: {
    selected: null
  },
  setup(__props: any) {

const props = __props as {
  selected: Array<{ venture: AccountType; ventureId: string }>
};



const inputs = computed(() => {
  return { ventureIds: props.selected.map((s) => s.ventureId), label: 'ESG' }
})
const { refetch, result } =
  useGetQuestionnairesForVenturesAndLabelQuery(inputs)

const esgTableRef = ref<{ refetch: () => void } | null>(null)
const selectedIds = ref<number[]>([])
const step = ref<'select' | 'edit'>('select')
const selectedForEdit = ref<
  Array<{ id: number; ventureId: string; venture: { name: string } }>
>([])

const openEditStep = () => {
  const all =
    result.value?.getQuestionnairesForVenturesAndLabel ?? []
  const byId = all.filter(
    (q: any) => q.id != null && selectedIds.value.includes(q.id as number),
  )
  selectedForEdit.value = byId.map((q: any) => ({
    id: q.id as number,
    ventureId: q.venture.id,
    venture: { name: q.venture.name },
  }))
  if (selectedForEdit.value.length > 0) {
    step.value = 'edit'
  }
}

async function onEditSaved(dialog: any) {
  step.value = 'select'
  await nextTick()
  esgTableRef.value?.refetch()
  refetch()
  dialog.value = false
}

return { __sfc: true,props, inputs, refetch, result, esgTableRef, selectedIds, step, selectedForEdit, openEditStep, onEditSaved }
}

})